// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Translations
import { withTranslation } from "react-i18next";
// Styles
import "components/Accordion/styles/styles.scss";
// Components
import IntegrationCard from "views/Bots/NLP/application/Build/Tabs/Intents/application/Integrations/integration_card";
import Centridesk from "views/Bots/NLP/application/Build/Tabs/Intents/application/Integrations/Channels/centridesk";
import ZendeskFull from "views/Bots/NLP/application/Build/Tabs/Intents/application/Integrations/Channels/zendesk_full";
import ChatGPT from "views/Bots/NLP/application/Build/Tabs/Intents/application/Integrations/Channels/chatgpt";
import Sunco from "views/Bots/NLP/application/Build/Tabs/Intents/application/Integrations/Channels/sunco";
// Material UI
import { Divider } from "@material-ui/core";

class Integrations extends Component {
  handleChannel = (channel) => {
    switch (channel) {
      case "zendesk_full":
        return <ZendeskFull {...this.props} />;
      case "centridesk":
        return <Centridesk {...this.props} />;
      case "sunco":
        return <Sunco {...this.props} />;
      case "chatgpt":
      case "gpt-3":
        return <ChatGPT {...this.props} />;
      default:
        break;
    }
  };

  updateData = () => {
    this.setState({ act: this.props.intent });
  };
  render() {
    const { integrations, intent } = this.props;

    const desk_name = intent.desks?.name;

    return (
      integrations.length > 0 && (
        <div>
          <div className={"intents__elements"}>
            <div className={"intents__element grid"}>
              <div className={"elements__integrations"}>
                {integrations.map((integration, i) => {
                  return (
                    <IntegrationCard
                      key={i}
                      {...this.props}
                      integration={integration}
                      updateData={this.updateData}
                    />
                  );
                })}
              </div>
              {[
                "zendesk_full",
                "centridesk",
                "sunco",
                "chatgpt",
                "gpt-3",
              ].includes(desk_name) && (
                <React.Fragment>
                  <Divider />
                  {this.handleChannel(desk_name)}
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      )
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state,
  };
};

const integrations_intent = connect(mapStateToProps)(Integrations);

export default withTranslation(["common", "languages"])(integrations_intent);
